import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgShortcutConfig } from './ng-shortcut';
import { NgShortcutComponent } from './ng-shortcut.component';
import { NgShortcutDirective } from './ng-shortcut.directive';
import { NgShortcutConfigService, NgShortcutService } from './ng-shortcut.service';

@NgModule({
  declarations: [NgShortcutComponent, NgShortcutDirective],
  imports: [],
  exports: [NgShortcutComponent, NgShortcutDirective],
})
export class NgShortcutModule {
  static forRoot(config?: NgShortcutConfig[]): ModuleWithProviders<NgShortcutModule> {
    return {
      ngModule: NgShortcutModule,
      providers: [
        NgShortcutService,
        {
          provide: NgShortcutConfigService,
          useValue: config,
        },
      ],
    };
  }
}
